import type { RouteObject } from 'react-router-dom'
import { Package, Stack, Truck } from '@phosphor-icons/react'
import { ROLES } from '@/auth/roles'
import type { PhoneTileDef } from '@/features/phone/tiles'
import { PackHomePage } from './pages/PackHomePage'
import { PackRunPage } from './pages/PackRunPage'
import { PackLotsPage } from './pages/PackLotsPage'
import { DispatchPage } from './pages/DispatchPage'
import { DelabelPage } from './pages/DelabelPage'
import { StoreByScope } from '@/features/store/v1/ByScope'
import { V1PackHome } from './v1/Home'
import { V1PackRun } from './v1/Run'
import { V1Dispatch, V1HallHome } from './v1/Hall'
import { V1PackLots } from './v1/Lots'
import { V1Delabel } from './v1/Delabel'

/**
 * Pack hall (F7) phone flows, mounted under /m: the pack line (start, fill and weigh, close with
 * code reconciliation), pack lots waiting for release, dispatch to a buyer, and emptying held
 * pouches.
 */
export const packRoutes: RouteObject[] = [
  // Seva Mandir V1: the pack line and hall boards (./v1); the full screens stay for the full build.
  { path: 'pack', element: <StoreByScope v1={<V1PackHome />} full={<PackHomePage />} /> },
  { path: 'pack/run/:runId', element: <StoreByScope v1={<V1PackRun />} full={<PackRunPage />} /> },
  { path: 'pack/hall', element: <StoreByScope v1={<V1HallHome />} full={<PackLotsPage />} /> },
  { path: 'pack/lots', element: <StoreByScope v1={<V1PackLots />} full={<PackLotsPage />} /> },
  { path: 'pack/dispatch', element: <StoreByScope v1={<V1Dispatch />} full={<DispatchPage />} /> },
  {
    path: 'pack/delabel/:runId',
    element: <StoreByScope v1={<V1Delabel />} full={<DelabelPage />} />,
  },
]

export const packTiles: PhoneTileDef[] = [
  {
    to: '/m/pack',
    title: 'pack.home.title',
    hint: 'pack.home.hint',
    icon: Package,
    team: 'SITE',
    roles: [ROLES.MACHINE_OPERATOR, ROLES.SUPERVISOR],
    primary: true,
    needs: 'PACK',
  },
  {
    to: '/m/pack/lots',
    title: 'pack.lots.title',
    hint: 'pack.lots.hint',
    icon: Stack,
    team: 'SITE',
    roles: [ROLES.MACHINE_OPERATOR, ROLES.STORE_KEEPER, ROLES.SUPERVISOR],
    needs: 'PACK',
  },
  {
    to: '/m/pack/dispatch',
    title: 'pack.dispatch.title',
    hint: 'pack.dispatch.hint',
    icon: Truck,
    team: 'SITE',
    roles: [ROLES.STORE_KEEPER, ROLES.SUPERVISOR],
    needs: 'PACK',
  },
]
